import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faInstagram,
  faSnapchat,
  faWhatsapp,
  faTiktok,
  
} from '@fortawesome/free-brands-svg-icons';
import { 
    faLocationDot,  // Address/Location
    faPhone,        // Phone
    faEnvelope      // Email
  } from '@fortawesome/free-solid-svg-icons';
export default function Footer(){
    return <div className="footer" id='footer'>
<div className="footer-container">
<div className="footer-description">
<h1 className="main-section-title">Pockets</h1>
<p>مزيج بين عالم الألعاب الإلكترونية والترفيه الرياضي مع كوفي شوب أنيق.
يفتح من الساعة 5م حتى 6 ص
عند الاشتراك الشهري في الغرف يتوفر خدمة المقهى والألعاب إلى الغرفة ونوفر الغرف شهرياً ويوميا وفي الساعة، للحجز تواصل معنا عبر مواقع التواصل الاجتماعي التالية   
</p>
              <ul className="soical-icons">
                
                <a href="https://snapchat.com/t/B17WxRDE"><FontAwesomeIcon icon={faSnapchat} className='social-icon'/></a>
                <a href="https://wa.me/+9660507737006"><FontAwesomeIcon icon={faWhatsapp} className='social-icon'/></a>
                <a href="https://www.tiktok.com/@pockets.8?_t=ZS-8vbhZjNly6B&_r=1"><FontAwesomeIcon icon={faTiktok} className='social-icon'/></a>
              </ul>
</div>
<div className="footer-image">
<img src={require('../images/pockets logo9ball -04.png')} alt='footer-image'/>
</div>
<div className='address-class'>
<p><FontAwesomeIcon icon={faLocationDot} className='icon'/> جدة حي الاجاويد</p>
<a href='mailto:info@pockets8.com'> <FontAwesomeIcon icon={faEnvelope} className='icon'/>info@pockets8.com</a>
<a href='tel:+966507737006'> <FontAwesomeIcon icon={faPhone} className='icon'/>0507737006</a>
</div>
</div>
<p className='copy-right'>جميع الحقوق محفوظة POCKETS 2025</p>
    </div >
}